<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div class="row">
        <div class="col"></div>
        <div class="col-12 col-md-8 col-lg-6">
            <SettingsCard
                id="SpaceAccessMenuKeysCard"
                :title="$t('labels.keys')"
                :subtitle="$t('messages.manageuserkeys')"
                to="/admin/doorsnkeys/keys"
            >
            </SettingsCard>
            <SettingsCard
                id="SpaceAccessMenuPoliciesCard"
                :title="$t('labels.policies')"
                :subtitle="$t('messages.configureaccesspolicies')"
                to="/admin/doorsnkeys/policy"
            >
            </SettingsCard>

            <SettingsCard
                id="SpaceAccessMenuLocksCard"
                :title="$t('labels.locks')"
                :subtitle="$t('messages.managespacelocks')"
                to="/admin/doorsnkeys/locks"
            >
            </SettingsCard>
        </div>
        <div class="col"></div>
    </div>
</template>

<script>
export default {
    name: 'AccessMenu',
    data() {
        return {
            space: this.$store.state.space,
        };
    },
    mounted() {},
};
</script>
